import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.25 6.167C8.25 4.5 9.759 3.25 11.5 3.25s3.25 1.251 3.25 2.917v5.666c0 .729-.289 1.378-.76 1.878l-1.064-1.064a1.27 1.27 0 0 0 .324-.814V6.167c0-.668-.658-1.417-1.75-1.417s-1.75.749-1.75 1.417V9.47l-1.5-1.5zm0 3.925v1.741c0 1.666 1.509 2.917 3.25 2.917.42 0 .826-.073 1.201-.207l-1.295-1.295c-1.036-.041-1.656-.766-1.656-1.415v-.24zm5.318 5.318a4.5 4.5 0 0 1-2.068.507c-1.245 0-2.449-.524-3.343-1.473-.896-.95-1.407-2.249-1.407-3.61V10a.75.75 0 0 0-1.5 0v.833c0 1.733.648 3.402 1.815 4.64a6.13 6.13 0 0 0 3.685 1.896v1.881H8.357a.75.75 0 0 0 0 1.5h6.286a.75.75 0 0 0 0-1.5H12.25v-1.88a6 6 0 0 0 2.417-.86zm2.277.156.09-.093c1.167-1.238 1.815-2.907 1.815-4.64V10a.75.75 0 0 0-1.5 0v.833c0 1.362-.51 2.66-1.407 3.61l-.059.062z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.53 18.628a.75.75 0 0 1-1.06 0L4.372 4.53a.75.75 0 1 1 1.061-1.06L19.53 17.567a.75.75 0 0 1 0 1.06",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }